/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Title/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function Title({
  children,
  viewPath = "/DesignSystem/TimelineEvent/Appointment/Title"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let latestEventsLastEventIdValueData = fromData.useDataValue({ viewPath,
context: 'latest_events',
path: 'last_event_id',
})
let eventValueData = fromData.useDataValue({ viewPath,
context: 'event',
})
let aggregateData = fromHelpers.getView(latestEventsLastEventIdValueData, eventValueData)
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(aggregateData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}